import { MY_SCHNEIDER_CONFIGURATORS_PAGE_SOURCE } from "../../constants";
import { appConfiguration } from "../app-starter";

export const isOnMyMSchneiderConfiguratorPage = () => {
  return appConfiguration.integrationSource === MY_SCHNEIDER_CONFIGURATORS_PAGE_SOURCE;
}
